export { SegmentedBar, STEP_BAR_HEIGHT, stepSegments } from "./SegmentedBar"
export type { BarSegment, SegmentedBarProps } from "./SegmentedBar"
